<template>
  <div class="keyword">
    <div class="keyword-item">
      <div class="keyword-item__content">
        <i class="el-icon-caret-top" v-if="keyword.progress"></i>
        <i class="el-icon-caret-bottom" v-if="!keyword.progress"></i>
        <p>{{ keyword.content }}</p>
      </div>
      <div class="keyword-item__ranking"><p>Position <span>{{ keyword.position }}</span></p></div>
      <div class="keyword-item__buttons">
        <el-button plain>View history</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['keyword'],
  data: () => ({}),
};
</script>
<style lang="scss">
.keyword {
  margin-bottom: 0;
  padding: 10px 25px;
  transition: background-color 0.3s ease;
  width: 100%;

  &:hover {
    background-color: #ffffff;
  }

  .keyword-item {
    width: inherit;
    display: flex;
    justify-content: space-between;
    font-size: 16px;

    p {
      display: inline-block;
      position: relative;
      margin-left: 10px;
      text-align: left;
      font-weight: 500;
    }

    &__ranking {
      display: flex;
      align-items: center;

      p {
        font-weight: 400;

        span {
          font-weight: 500;
        }
      }
    }

    &__buttons {
      display: flex;
      align-items: center;
    }
  }

  .el-icon-caret-top {
    color: #00d457;
  }

  .el-icon-caret-bottom {
    color: #ff5960;
  }

  .el-button {
    padding: 6px 16px;
    margin: 0;
    width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Keyword.vue